import { useState } from 'react'

import {
  getChatCounters,
  getCommonCounters,
  getNewsboardCounters,
} from '../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../constants/common'
import { ROUTE_UI_SECTION_NAME } from '../constants/route'
import { CountersActionsContext, CountersContext } from '../context'
import { useInitData } from '../hooks'
import { getSectionCanViewPermission } from '../utils/common'

function CountersProvider({ children }) {
  const [counterData, setCounterData] = useState(null)

  const { sections = EMPTY_OBJECT } = useInitData()

  async function refetchCounters() {
    // Independent requests — fire them together so a route change doesn't pay
    // the sum of their latencies. Refresh is best-effort: a failed poll keeps
    // the previous values.
    const [commonResponse, newsboardResponse, chatResponse] = await Promise.all(
      [
        getCommonCounters(),
        getSectionCanViewPermission(sections, ROUTE_UI_SECTION_NAME.newsboard)
          ? getNewsboardCounters()
          : null,
        getSectionCanViewPermission(sections, ROUTE_UI_SECTION_NAME.chats)
          ? getChatCounters()
          : null,
      ]
    ).catch(() => EMPTY_LIST)

    if (commonResponse) {
      setCounterData({
        ...commonResponse.data,
        ...(chatResponse?.data ?? EMPTY_OBJECT),
        ...(newsboardResponse?.data ?? EMPTY_OBJECT),
      })
    }
  }

  return (
    <CountersContext value={counterData}>
      <CountersActionsContext value={refetchCounters}>
        {children}
      </CountersActionsContext>
    </CountersContext>
  )
}

export default CountersProvider
